"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/inline-style-prefixer/utils/addNewValuesOnly.js
// module id = ../node_modules/inline-style-prefixer/utils/addNewValuesOnly.js
// module chunks = 0